import { Box, Card, Divider, Skeleton } from '@mui/material';
import Grid from '@mui/material/Grid2';
import React from 'react';

interface IProps {
  sm?: number;
  nbToLoop?: number;
}

const InvoiceStatisticsSkeleton = ({ sm = 3, nbToLoop = 4 }: IProps) => {
  return (
    <Grid container spacing={2} sx={{ mb: '20px' }}>
      {Array.from({ length: nbToLoop }).map((_, i) => (
        <Grid key={i} size={{ xs: 12, sm }}>
          <Card sx={{ pb: '10px' }}>
            <Box display="flex" alignItems="center" mb={2}>
              <Skeleton variant="circular" width={40} height={40} />
              <Skeleton variant="text" width="60%" height={28} sx={{ ml: 2 }} />
            </Box>

            <Skeleton variant="text" width="50%" height={36} />
            <Divider sx={{ my: 1 }} />
            <Skeleton variant="text" width="70%" height={20} />
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default InvoiceStatisticsSkeleton;
